// @owners { team: patient-health }
import { type ActionEditReminders, EDIT_REMINDERS } from '~shared/actions/ui/reminders';

type Action = ActionEditReminders;

export type StateUiReminders = {
  editingReminders: boolean;
};

export const initialState = {
  editingReminders: false,
};

export default (state: StateUiReminders = initialState, action: Action) => {
  switch (action.type) {
    case EDIT_REMINDERS: {
      const { payload } = action;

      return { ...state, editingReminders: payload };
    }

    default:
      return state;
  }
};
